import { BaseDto } from '../base.dto';
import { ConfigurationDto } from './config.dto';

export class ConfigurationValueDto extends BaseDto {
  merchantId?: number;
  group: string;
  configurationTypeId?: number;
  configurationType?: ConfigurationDto;
  value?: string;
}
